import script from "./AgentBulkActionMenu.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentBulkActionMenu.linux.vue?vue&type=script&setup=true&lang=ts"

import "./AgentBulkActionMenu.linux.vue?vue&type=style&index=0&id=7dd04db0&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd04db0"]])

export default __exports__